import { useMemo } from 'react';
import { useFloorPlanState } from '../../../../../../../stateProviders/FloorPlanStateProvider';

export const useCalculateJoistAssemblies = () => {
    const floorPlanState = useFloorPlanState(); 

    const numberOfJoistAssembliesNeeded = useMemo( () => {
        const wallLengthsOfWallThatNeedJoists = floorPlanState.walls.find( wall => wall.wallType === 'houseAttached')?.lengthInInches || 0
        //calculation is deck width (perpendicular to house) divided by 16 inches (joist spacing) minus 1 rounded up
        return Math.ceil(wallLengthsOfWallThatNeedJoists / 16) - 1
    },[floorPlanState.walls])

    return numberOfJoistAssembliesNeeded
}